<template>
    
    <div class="main">
        <c-panel>
            <form-deficiencia :paramId="$route.params.id" v-on:onSubmitDeficiencia="onSubmitDeficiencia"></form-deficiencia>
        </c-panel>
    </div>
    
</template>
<script>

import formDeficiencia from "./form"

export default {
    methods:{

        onSubmitDeficiencia(){

            this.$router.push('/admin/dados-medicos/2');
        }
    },
    components:{ formDeficiencia }
}
</script>
